<style>
  @import "../account.scss";
</style>

<script>
import ConsumerService from '../account-consumer.service'
import { EventBus } from '../../../event-bus'

const consumerService = new ConsumerService()

export default {
  name: 'ConsumerLogin',
  components: {

  },
  data () {
    return {
      consumer: {
        email: '',
        password: ''
      },
      submitted: false,
      errorMessage: false,
      logInSuccess: ''
    }
  },
  methods: {
    /**
      * This method will call the login Api with valid credentials
      */
    handleSubmit (e) {
      this.submitted = true
      this.$validator.validate().then(valid => {
        if (valid) {
          consumerService.login(this.consumer).then(res => {
            this.errorMessage = ''
          }).catch(error => {
            this.errorMessage = (error.response.data || {}).message || 'Something went wrong.'
            setTimeout(() => {
              if (error.response.status === 403) {
                this.gotToForgetPwd()
              }
            }, 3000)
          })
        }
      })
    },

    /**
     * This method routes to register page
     */
    goToRegister () {
      EventBus.$emit('switchConsumerPage', 'consumerRegister')
    },

    /**
     * route to forget password
     */
    gotToForgetPwd () {
      EventBus.$emit('switchConsumerPage', 'forgetPwd')
    }
  }
}
</script>

<template>
  <div
    id="consumer-login"
    class="py-5"
  >
    <div
      v-if="errorMessage"
      class="alert alert-danger mx-auto col-sm-12 col-md-10"
      role="alert"
    >
      {{ errorMessage }}
    </div>
    <div>
      <h5 class="text-center">
        {{ $t ('label.consumerSignIn') }}
      </h5>
      <div class="src-user-icon my-5">
        <i class="fa fa-user-circle-o text-primary fa-5x" />
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="form-group mx-auto col-sm-12 col-md-8">
          <input
            v-validate="{ required: true, email: true }"
            id="consumerEmail"
            v-model="consumer.email"
            :class="{ 'is-invalid': submitted && errors.has('email') }"
            name="email"
            placeholder="Consumer user name"
            type="email"
            class="form-control"
          >
          <div
            v-if="submitted && errors.has('email')"
            class="invalid-feedback">{{ errors.first('email') }}</div>
        </div>
        <div class="form-group mx-auto col-sm-12 col-md-8">
          <input
            v-validate="{ required: true }"
            id="consumerPassword"
            v-model="consumer.password"
            :class="{ 'is-invalid': submitted && errors.has('password') }"
            type="password"
            placeholder="Password"
            name="password"
            class="form-control" >
          <div
            v-if="submitted && errors.has('password')"
            class="invalid-feedback">{{ errors.first('password') }}</div>
        </div>
        <small
          id="loginMsg"
          class="form-text text-muted text-center mt-5 small-txt"
        >
          {{ $t ('label.loginMsg') }}
        </small>
        <small
          id="billingAddressMsg"
          class="form-text text-muted text-center small-txt"
        >
          {{ $t ('label.billingAddressMsg') }}
        </small>

        <div class="mx-auto mt-4 col-sm-8 col-md-8">
          <button
            class="btn btn-primary btn-block"
          >
            {{ $t('label.signIn') }}
          </button>
        </div>
        <div class="text-center mt-4">
          <a
            href="javascript:;"
            @click="gotToForgetPwd"> {{ $t('label.forgotPassword') }}</a>
          <a
            href="javascript:;"
            @click="goToRegister"> {{ $t('label.signUp') }}</a>
        </div>
      </form>
    </div>
  </div>
</template>
